// 言币申请状态
export enum ORDER_STATUS {
  WAIT = 0, // 待生效
  EFFECT = 1, // 权益生效中
  EXPIRED = 99, // 权益已过期
}
